import {sounds} from "../sounds/sound";
import {store} from "../store";
import {Howl} from "howler";


export const MusicService = {

    tutorialMusic: null as any,

    battleMusic: null as any,

    menuMusic: null as any,

    afterBattle: null as any,

    playBattleWin: function (sound: any) {

        if(MusicService.afterBattle === null) {
            MusicService.afterBattle = sound;
            MusicService.afterBattle.play();
        }
    },
    stopBattleWin: function () {

        if (MusicService.afterBattle !== null) {
            MusicService.afterBattle.stop();
        }
        MusicService.afterBattle = null;
    },

    playTutorial: function () {

        /*  MusicService.tutorialMusic = new Howl({
               src: sounds.getTutorialRandomMusic(),
               volume: 0.3,
               onend: function(){
                  if(MusicService.tutorialMusic !== null){
                      MusicService.playTutorial();
                  }
               }
              });

              MusicService.tutorialMusic.play();     */
    },

    stopTutorial: function () {
        if (MusicService.tutorialMusic !== null) {
            MusicService.tutorialMusic.stop();
        }
        MusicService.tutorialMusic = null;
    },

    playBattleMusic: function () {
        let state = store.getState();
        if (state.auth.music.playBattle === false) {
            return;
        }

        if (MusicService.battleMusic !== null) {
            return;
        }

        const battleMusic = new Howl({
            src: sounds.getBattleRandomMusic(),
            volume: 0.3,
            onend: function () {
                if (MusicService.battleMusic === battleMusic) {
                    MusicService.battleMusic = null;
                    MusicService.playBattleMusic();
                }
            }
        });

        MusicService.battleMusic = battleMusic;
        battleMusic.play();
    },

    stopBattle: function () {
        const battleMusic = MusicService.battleMusic;
        MusicService.battleMusic = null;

        if (battleMusic !== null) {
            battleMusic.stop();
            battleMusic.unload();
        }
    },

    playMenuMusic: function () {
        let state = store.getState();
        if (!state.auth.music.playMenu) {
            return;
        }
        if (MusicService.menuMusic !== null) {
            return;
        }

        const menuMusic = new Howl({
            src: sounds.getMenuRandomMusic(),
            volume: 0.3,
            onend: function () {
                if (MusicService.menuMusic === menuMusic) {
                    MusicService.menuMusic = null;
                    MusicService.playMenuMusic();
                }
            }
        });

        MusicService.menuMusic = menuMusic;
        menuMusic.play();
    },

    stopMenu: function () {
        const menuMusic = MusicService.menuMusic;
        MusicService.menuMusic = null;

        if (menuMusic !== null) {
            menuMusic.stop();
            menuMusic.unload();
        }
    },

}
